export const Logo = require('./logo.png')
export const Login = require('./login.png')
export const LoginMin = require('./logo-min.png')